import { Alert, Link, Typography } from '@montugroup/design-system';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { Grid } from '@mui/material';
import { useTour } from '@reactour/tour';

export const AutosaveTourBanner = () => {
  const { setIsOpen } = useTour();
  return (
    <Grid item xs={12}>
      <Alert icon={<InfoOutlineIcon fontSize="inherit" />} severity="info">
        <Typography fontWeight={600}>New feature: Autosave</Typography>
        <Typography>
          Autosave is on! To learn more, head to this{' '}
          <Link
            href="https://app.getguru.com/card/cqE84y9i/PMS-Autosave"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            <strong>Guru card</strong>
          </Link>{' '}
          or take the{' '}
          <Link component="button" underline="hover" onClick={() => setIsOpen(true)} aria-label="open tour">
            <strong>tour</strong>
          </Link>{' '}
        </Typography>
      </Alert>
    </Grid>
  );
};
